// @flow
import React from "react";
import { get, noop } from "lodash";
import type { NullaryFn } from "@tvg/types/Functional";
import type { RaceVideoFeedback } from "@tvg/types/Race";

import { useNewWatchLiveButton } from "@urp/sh-lib-amplitude-experiments";
import Button from "../../_atoms/Button";
import BuildButtonInfo from "./VideoButtonInfo";
import { videoMessages } from "./VideoButtonInfo/constraints";
import { BuildButtonInfoForExperiment } from "./VideoButtonInfo/ButtonInfoForExperiment";

export type Props = {
  /**
   * state of the button in a given button, defined by the feedback message to the user
   */
  feedback: RaceVideoFeedback,
  /**
   * size of the button
   */
  small?: boolean,
  /**
   * on click callback
   */
  onClick: NullaryFn<void>,
  /**
   * type of copy being used
   */
  isShortCopy?: boolean,
  /**
   *  Use Night mode style
   */
  isNightMode?: boolean
};

const VideoButton = ({
  feedback,
  small = false,
  isShortCopy,
  isNightMode = false,
  onClick = noop
}: Props) => {
  const isReplay = feedback.includes("AVAILABLE_REPLAY");
  const startingSoonNoReplay = feedback.includes("STARTING_SOON_NO_REPLAY");
  const isDisabled =
    feedback.indexOf("AVAILABLE") !== 0 &&
    feedback.includes("NO_REPLAY") &&
    !startingSoonNoReplay;
  const isVideoAvailable = feedback.includes("AVAILABLE_NO_REPLAY");
  const isExperimentActive = useNewWatchLiveButton();

  return !isDisabled ? (
    <Button
      type={isReplay && !startingSoonNoReplay ? "secondary" : "primary"}
      onClick={onClick}
      isStretched={!small}
      size="big"
      qaLabel={`raceCardHeader-${get(
        videoMessages,
        `[${feedback}]`,
        ""
      ).replace(" ", "")}`}
      isDisabled={startingSoonNoReplay}
      isNightMode={isNightMode}
    >
      {isExperimentActive && isVideoAvailable
        ? BuildButtonInfoForExperiment({ isNightMode, isReplay, small })
        : BuildButtonInfo({
            feedback,
            small,
            isReplay,
            isShortCopy,
            isNightMode
          })}
    </Button>
  ) : null;
};

export default VideoButton;
